// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDf0tRw3S3HcDp6HkQ33vy8VXyB0xEhpTg",
    authDomain: "car-detailing-blog.firebaseapp.com",
    databaseURL: "https://car-detailing-blog.firebaseio.com",
    projectId: "car-detailing-blog",
    storageBucket: "",
    messagingSenderId: "787581303037",
    appId: "1:787581303037:web:c2f26c7d7a44982b"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
